import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { Check } from "@frui.ts/bootstrap";
import styles from "./roadLayerSelection.module.scss";
import TradingPlacesViewModel from "../../../viewModels/tradingPlaces/tradingPlacesViewModel";
import { RadioArray } from "../../../controls/radioArray";

type Props = {
  vm: TradingPlacesViewModel;
};

const RoadLayerSelection = observer(({ vm }: Props) => {
  return (
    <div className={styles.container}>
      <div className={classNames(styles.content, styles.col)}>
        <div className={styles.checkboxGroup}>
          <div className={classNames(styles.checkbox, styles.freeCheckbox)}>
            <Check autoComplete="off" custom target={vm.visibleRoads} property="free" label={vm.translate("tollFreeRoads")} />
          </div>
          <div className={classNames(styles.checkbox, styles.paidCheckbox)}>
            <Check autoComplete="off" custom target={vm.visibleRoads} property="paid" label={vm.translate("tollPaidRoads")} />
          </div>
        </div>
        {(vm.visibleRoads.free || vm.visibleRoads.paid) && (
          <div className={styles.row}>
            <div className={styles.radioGroup}>
              {vm.roadMapYears.map((year) => (
                <RadioArray
                  custom
                  key={year}
                  label={year}
                  target={vm.visibleRoads}
                  property="year"
                  option={year}
                  isNumeric={true}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default RoadLayerSelection;
